// extracted by mini-css-extract-plugin
module.exports = {"body":"BodyWrapper_body__1jXBD","content":"BodyWrapper_content__G2uws"};